import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";
import {
  ControlContainer,
  UntypedFormBuilder,
  UntypedFormGroup,
  FormGroupDirective,
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import { CanvasService } from "@services/canvas.service";

@Component({
    selector: "app-linking-component",
    templateUrl: "./linking.component.html",
    styleUrls: ["./linking.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class LinkingComponent implements OnInit, OnChanges {
  constructor(
    public parentF: FormGroupDirective,
    private canvasService: CanvasService,
    private fb: UntypedFormBuilder,
    private http: HttpClient
  ) {}

  @Input() currentDataFields!: any;
  @Input() drilldowndata!: any;
  @Input() workflows!: any;
  @Output() chartDataChange = new EventEmitter<any>();
  @Input() chartType!: any;

  public fieldForm!: UntypedFormGroup;
  public childForm: any;
  public aggregateData: any = [];
  public reportTitle!: string;
  public editForm!: UntypedFormGroup;
  public currentDataSets: any[] = [];
  field: any;
  auto: any;
  fieldData: any;
  fieldsHidden: boolean = false;
  message: string = "Are you sure?";
  name: string = "";
  type: string = "";
  public formFields: any[] = [];
  faExclamationTriangle = faExclamationTriangle;
  selected: string = "";
  changeFlow() {
    this.childForm.get("drilldownLinkId").setValue(null);
    if (this.childForm.get("drilldownLinkType").value == "dataset") {
      if (this.currentDataSets.length == 1) {
        this.childForm
          .get("drilldownLinkId")
          .setValue(this.currentDataSets[0].id);
      }
    }

    if (this.childForm.get("drilldownLinkType").value == "workflow") {
      if (this.workflows.data.length == 1) {
        this.childForm
          .get("drilldownLinkId")
          .setValue(this.workflows.data[0].id);
      }
    }
    this.buildAggregateData();
  }
  buildAggregateData() {
    let callPreview = false;
    if (this.childForm) {
      if (this.childForm.get("drilldownEnabled").value) {
        const linkType = this.childForm.get("drilldownLinkType")?.value;
        const linkId = this.childForm.get("drilldownLinkId")?.value;

        if ([linkType, linkId].every(
          v => v !== null && v !== undefined && v.toString().trim() !== ""
        )) {
          callPreview = true;
        }
      } else if (this.childForm.get("drilldownEnabled")?.dirty) {
        callPreview = true;
      }

      if (callPreview) {
        this.canvasService.refreshCanvas(this.childForm).subscribe(
          (success: any) => {
            this.canvasService.triggerEnable();
            const data = success.data;
            this.canvasService.pushChartToStorage(data);
            this.canvasService.populateCanvas(data);
          },
          (error: any) => {
            this.canvasService.triggerEnable();
            const data = this.canvasService.getChartFromStorage();
            this.canvasService.populateCanvas(data);
          }
        );
      }
    }
  }
  findUniqueDataSets() {
    let fieldItem = {};
    this.currentDataSets = [];
    this.currentDataFields.forEach((element: any) => {
      fieldItem = {
        id: element.dataSet.data.id,
        name: element.dataSet.data.name,
      };
      this.currentDataSets.push(fieldItem);
    });
    const arrUniq = [
      ...new Map(this.currentDataSets.map((v) => [v.id, v])).values(),
    ];
    arrUniq.sort(function (a, b) {
      return a.name
        .toString()
        .toLowerCase()
        .localeCompare(b.name.toString().toLowerCase());
    });

    this.currentDataSets = arrUniq;

    //set list to only the first item
    // this.currentDataSets = [];
    // this.currentDataSets.push(arrUniq[0]);

    if (
      this.currentDataSets.length == 1 &&
      this.childForm &&
      this.childForm.get("drilldownLinkType").value == "dataset" &&
      this.currentDataSets[0].id != this.childForm.get("drilldownLinkId").value
    ) {
      this.changeFlow();
    }
  }
  ngOnChanges(): void {
    if (!this.childForm) {
      this.childForm = this.parentF.form;
    }
    if (this.currentDataFields) {
      this.findUniqueDataSets();
    }
    // if (this.workflows && this.workflows.data.length <= 0) {
    //   this.childForm.get("drilldownLinkType").setValue("dataset");
    //   this.changeFlow();
    // }
  }

  ngOnInit(): void {
    this.childForm = this.parentF.form;
    if (this.currentDataFields) {
      this.findUniqueDataSets();
    }
    if (this.workflows && this.workflows.data.length <= 0) {
      this.childForm.get("drilldownLinkType").setValue("dataset");
      this.changeFlow();
    }
  }
}
